import type { FaireProductEntity } from "../../entity_types/product";

export const p_3frtvml4: FaireProductEntity = {
  token: "p_3frtvml4",
  type: "product",
  name: "Thanks A Latte",
  brandToken: "b_1sahwzac",
  brandName: "Hammerpress",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e6943d88b542bccec3010c89b6a8e02d6f12e6c67ff98019899c999f0c55aeae/1544022073.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/100bc0ded5d511dec803716b05ed8387b32b53eafaa099afd1f905b6997ae6ef.jpeg",
  ],
  priceDollars: 3,
  description:
    'Folding note card with kraft envelope. Letterpress printed on 110lb. Recycled white paper. Blank inside.\n\nCard size: 4.25" x 5.50" (folded).\n\nPackaged in plant-based polylactic acid (PLA) certified compostable bag.\n\nDesigned and letterpress printed at our studio in Kansas City, Missouri. Made in USA.',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:19.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
